import { Component, Input, OnInit, ElementRef, ViewChild, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { ECharts } from 'echarts'
import { fromEvent } from "rxjs";
import { debounceTime } from "rxjs/operators";
import { CommonService } from "../../service/common.service";
import * as _ from 'lodash'
import { NoiseEventWaveService } from './noise-event-wave.service'
import { NoisEventWaveParam } from './noise-event-wave-interface'

@Component({
  selector: 'bcac-noise-event-wave',
  templateUrl: './noise-event-wave.component.html',
  styleUrls: ['./noise-event-wave.component.scss']
})
export class NoiseEventWaveComponent implements OnInit {

  constructor(
    private noiseWaveService: NoiseEventWaveService,
    private commonService: CommonService,
  ) { }

  @Output() bcacGetChartInstance: EventEmitter<ECharts> = new EventEmitter<ECharts>();


  Option: any = this.noiseWaveService.getDefaultOpitonsOfEventWave()


  public _bcacChartTitle: { show: boolean, label: string } = {
    show: true,
    label: "噪声事件波形图"
  };

  //todo 是否显示标题
  @Input()
  set bcacChartShowTitle(show: boolean) {
    this._bcacChartTitle.show = typeof (show) == "string"
      ? JSON.parse(show)
      : show;
  }
  //todo 标题文字
  @Input()
  set bcacChartTitleText(text: string) {
    this._bcacChartTitle.label = text;
  }


  // todo 下载文件名
  public _bcacChartFileName = "图表";
  @Input()
  set bcacChartFileName(fileName: string) {
    this._bcacChartFileName = fileName;
  }

  //todo 是否显示toolbox
  _isShowToolbox
  @Input()
  set bcacChartShowToolbox(show: boolean | string) {
    this._isShowToolbox = typeof (show) == "string"
      ? JSON.parse(show)
      : show;
    this.Option.toolbox.show = this._isShowToolbox
  }

  //todo loading状态
  public _bcacChartLoading: boolean = false;
  @Input()
  set bcacChartLoading(loading: boolean) {
    this._bcacChartLoading = loading;
  }

  //todo x轴名称
  @Input()
  set bcacXAxisName(bcacXaxisName: string) {
    this.Option.xAxis[0].name = bcacXaxisName
  }

  //todo y轴名称
  _bcacYAxisName
  @Input()
  set bcacYAxisName(bcacYaxisName: string) {
    this.Option.yAxis[0].name = bcacYaxisName
    this._bcacYAxisName = bcacYaxisName
  }

  //todo  y轴名称距离
  @Input()
  set bcacYAxisNameGap(yAxisNameGap: number | string) {
    this.Option.yAxis[0].nameGap = Number(yAxisNameGap)
  }
  //todo x轴刻度标签旋转
  @Input()
  set bcacXAxisLabelRotate(xAxisLabelRotate: number) {
    this.Option.xAxis[0].axisLabel.rotate = xAxisLabelRotate;
  }
  //todo  y轴刻度标签旋转
  @Input()
  set bcacYAxisLabelRotate(yAxisLabelRotate: number) {
    this.Option.yAxis[0].axisLabel.rotate = yAxisLabelRotate;
  }
  //todo tooltip显示格式化
  @Input()
  set bcacTooltipFormatter(value: any) {
    this.Option.tooltip = this.noiseWaveService.setTooltipFormat(value);
  }


  //todo 图数据
  @Input()
  set bcacChartData(data: NoisEventWaveParam) {
    if (data
      && data.xAxisDatas
      && Array.isArray(data.xAxisDatas)
      && data.seriesDatas
      && Array.isArray(data.seriesDatas)
      ) {
      this.Option.xAxis[0].data = data.xAxisDatas
      if (data.xFormatter) {
        this.Option.xAxis[0].axisLabel.formatter = data.xFormatter
      }
      if (data.xInterval) {
        this.Option.xAxis[0].axisLabel.interval = data.xInterval
      }
      let ydata = []
      let legend = []
      for (const item of data.seriesDatas) {
        legend.push(item.name)
        ydata.push({
          name: item.name,
          data: item.data,
          type: 'line',
          smooth: true,
        })
      }
      this.Option.series = ydata
      this.Option.legend.data = legend
    } 
  }



  ngOnInit() {
    this.renderGraph()
    fromEvent(window, "resize")
      .pipe(debounceTime(200))
      .subscribe(() => {
        let style = this.commonService.setNoiseDropboxLine();
        if (this.echartInstance) {
          this.echartInstance.setOption({
            toolbox: {
              itemSize: style.toolbox.itemSize,
              itemGap: style.toolbox.itemGap,
            },
            grid: style.grid,
            legend: {
              itemSize: style.legend.itemSize,
              itemGap: style.legend.itemGap
            },
          });
        }
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    this.updateOption()
  }

  updateOption() {
    if (this.echartInstance) {
      let option = this.Option
      this.echartInstance.setOption(option, true);
    }
  }


  //todo 渲染图
  chartOption;//图option
  renderGraph() {
    this.chartOption = this.Option
  }

  //todo 获取实例
  echartInstance;
  onOptionInit(ec) {
    this.echartInstance = ec;
    this.bcacGetChartInstance.emit(ec)
  }








}
